import React, { Component } from 'react';
import { ApiClient } from "../../libs/apiClient";
import { SERVICE_RESPONSE } from '../../libs/utils/Const';
import download from 'js-file-download';
let apiClient = ApiClient.getInstance();

class EmployeeNominaModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
        };
    }

    componentDidMount = async () => {
        // this.CallNominaInfoCatalogs()
    }

    CloseModal = () => {
        const { model, closeModalActions } = this.props;
        // this.restartTabs();
        closeModalActions()
    }

    ChangeModelPropByKey = (key, event) => {
        const { model, refreshModel } = this.props;
        let copyModel = Object.assign({}, model);
        copyModel[key] = event.target.value
        refreshModel(copyModel);
    }

    ValidateEmployeeModel = () => {
        const { model, showAlert } = this.props
        // let flag = true;
        if (false) {
            showAlert({ type: 'info', message: `Favor de llenar el campo `, timeOut: 5000 });

        }

        return true;
    }


    sendModel = () => {
        if (this.ValidateEmployeeModel()) {
            this.props.sendModel()
        }
    }

    render() {
        const { action, model, acceptDeleteModel } = this.props;
        const { editMode, } = this.state;

        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll" id="EmployeeNominasModal" role="dialog" aria-hidden="true" >

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DATOS DEL EMPLEADO</h4>
                            <button type="button" className="close" onClick={this.CloseModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.renderEditButton()}
                                                {this.renderHeaderFields()}
                                                <br></br><br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">

                            {/* {action != 1 && !editMode && view !== 'consignmentNote' && (
                                <button type="button" className="btn botonCerrar text-white" style={{ background: '#c42222 !important' }} onClick={this.deleteModel}>
                                    Eliminar
                                </button>
                            )} */}

                            <button type="button" className="btn botonCerrar text-white" onClick={this.CloseModal}>Cerrar
                            </button>
                            {action === 1 && <button type="button" className="btn botonCorrect text-black"
                                onClick={this.sendModel}> Crear</button>}
                            {action === 2 && editMode && (
                                <button type="button" className="btn btn-danger text-white" onClick={() => this.openCloseAgreeModal(true)}>
                                    Eliminar
                                </button>
                            )}
                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.acceptEditMode}>
                                    Guardar
                                </button>
                            )}

                            {action === 2 && editMode && (
                                <button type="button" className="btn botonCorrect" onClick={this.cancelEditMode}>
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>


            </div >
        );
    }

    //#region render visual
    renderEditButton = () => {
        const { action, view } = this.props;
        const { editMode } = this.state;
        if (action === 2 && !editMode) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    renderInput = (label, value, onChange, disabled, type = "text") => (
        <div className="input-group mb-3">
            <div className="input-group-prepend">
                <span className="input-group-text font-weight-bold">{label}</span>
            </div>
            <input type={type} className="form-control" value={value || ""} onChange={onChange} disabled={disabled} />
        </div>
    );

    renderSelect = (label, value, options, onChange, disabled) => (
        <div className="input-group mb-3">
            <div className="input-group-prepend">
                <span className="input-group-text font-weight-bold">{label}</span>
            </div>
            <select className="form-control" value={value || ""} onChange={onChange} disabled={disabled}>
                {options && options.map((opt, idx) => (
                    <option key={idx} value={opt.value}>{opt.label}</option>
                ))}
            </select>
        </div>
    );


    renderHeaderFields = () => {
        const { model, action } = this.props;
        const { editMode } = this.state;
        const isDisabled = (action === 2 && !editMode);

        return (
            <div className="container">
                {/* RECEPTOR */}
                <h5 className="mt-4 mb-2">Receptor</h5>
                <div className="row">
                    <div className="col-md-6">
                        {this.renderInput("Nombre", model.RecepNombre, (e) => this.ChangeModelPropByKey("RecepNombre", e), isDisabled)}
                        {this.renderInput("RFC", model.RecepRfc, (e) => this.ChangeModelPropByKey("RecepRfc", e), isDisabled)}
                        {this.renderInput("Uso CFDI", model.RecepUsoCfdi, (e) => this.ChangeModelPropByKey("RecepUsoCfdi", e), isDisabled)}
                    </div>
                    <div className="col-md-6">
                        {this.renderInput("Régimen Fiscal", model.RecepRegimenFiscal, (e) => this.ChangeModelPropByKey("RecepRegimenFiscal", e), isDisabled)}
                        {this.renderInput("Domicilio Fiscal", model.RecepDomicilioFiscal, (e) => this.ChangeModelPropByKey("RecepDomicilioFiscal", e), isDisabled)}
                    </div>
                </div>
                {/* INFORMACIÓN DE NÓMINA */}
                <h5 className="mt-4 mb-2">Datos de Nómina</h5>
                <div className="row">
                    <div className="col-md-6">
                        {this.renderInput("CURP", model.NomRecepCurp, (e) => this.ChangeModelPropByKey("NomRecepCurp", e), isDisabled)}
                        {this.renderInput("Cuenta Bancaria", model.NomRecepCuentaBancaria, (e) => this.ChangeModelPropByKey("NomRecepCuentaBancaria", e), isDisabled)}
                        {this.renderInput("NSS", model.NomRecepNumSeguridadSocial, (e) => this.ChangeModelPropByKey("NomRecepNumSeguridadSocial", e), isDisabled)}
                        {this.renderInput("Fecha Inicio Rel. Laboral", model.NomRecepFechaInicioRelLaboral, (e) => this.ChangeModelPropByKey("NomRecepFechaInicioRelLaboral", e), isDisabled, "date")}
                        {this.renderInput("Antigüedad", model.NomRecepAntiguedad, (e) => this.ChangeModelPropByKey("NomRecepAntiguedad", e), isDisabled)}
                        {this.renderInput("Tipo Contrato", model.NomRecepTipoContrato, (e) => this.ChangeModelPropByKey("NomRecepTipoContrato", e), isDisabled)}
                        {this.renderInput("Sindicato", model.NomRecepSindicato, (e) => this.ChangeModelPropByKey("NomRecepSindicato", e), isDisabled)}
                        {this.renderInput("Tipo Jornada", model.NomRecepTipoJornada, (e) => this.ChangeModelPropByKey("NomRecepTipoJornada", e), isDisabled)}
                        {this.renderInput("Tipo Régimen", model.NomRecepTipoRegimen, (e) => this.ChangeModelPropByKey("NomRecepTipoRegimen", e), isDisabled)}
                    </div>
                    <div className="col-md-6">
                        {this.renderInput("Número Empleado", model.NomRecepNumEmpleado, (e) => this.ChangeModelPropByKey("NomRecepNumEmpleado", e), isDisabled)}
                        {this.renderInput("Departamento", model.NomRecepDepartamento, (e) => this.ChangeModelPropByKey("NomRecepDepartamento", e), isDisabled)}
                        {this.renderInput("Puesto", model.NomRecepPuesto, (e) => this.ChangeModelPropByKey("NomRecepPuesto", e), isDisabled)}
                        {this.renderInput("Riesgo Puesto", model.NomRecepRiesgoPuesto, (e) => this.ChangeModelPropByKey("NomRecepRiesgoPuesto", e), isDisabled)}
                        {this.renderInput("Periodicidad de Pago", model.NomRecepPeriodicidadPago, (e) => this.ChangeModelPropByKey("NomRecepPeriodicidadPago", e), isDisabled)}
                        {this.renderInput("Salario Base Cot. Ap.", model.NomRecepSalarioBaseCotAPor, (e) => this.ChangeModelPropByKey("NomRecepSalarioBaseCotAPor", e), isDisabled, "number")}
                        {this.renderInput("Salario Diario Integrado", model.NomRecepSalarioDiarioIntegrado, (e) => this.ChangeModelPropByKey("NomRecepSalarioDiarioIntegrado", e), isDisabled, "number")}
                        {this.renderInput("Clave Entidad Federativa", model.NomRecepClaveEntFed, (e) => this.ChangeModelPropByKey("NomRecepClaveEntFed", e), isDisabled)}
                    </div>
                </div>

            </div>
        );
    };


    //#endregion
}



export default EmployeeNominaModal;